// @flow

import React from 'react';
import PropTypes from 'prop-types';

import {
    Typography,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    FormControlLabel,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import './style.css';

type Props = {
    data: Array<any>,
};

function Collapsible(props: Props) {
    const { data } = props;
    const [expandedIndex, setExpandedIndex] = React.useState();
    const handleExpansionPanelChange = (panelIndex) => (event, newExpanded) => {
        setExpandedIndex(newExpanded ? panelIndex : false);
    };

    return (
        <Typography component="div" className="collapsible">
            {data.map((row, index) => {
                return (
                    <ExpansionPanel
                        key={index}
                        square
                        defaultExpanded
                        onChange={handleExpansionPanelChange(index)}
                        expanded={expandedIndex === index}
                    >
                        <ExpansionPanelSummary>
                            <FormControlLabel
                                control={
                                    expandedIndex === index ? (
                                        <RemoveIcon />
                                    ) : (
                                        <AddIcon />
                                    )
                                }
                                label={row.Title}
                                className="row-title"
                            />
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Typography component="p"></Typography>
                            <Typography
                                component="span"
                                dangerouslySetInnerHTML={{
                                    __html: row.Content,
                                }}
                            ></Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                );
            })}
        </Typography>
    );
}

Collapsible.propTypes = {
    data: PropTypes.array,
};

export default Collapsible;
